import { render, staticRenderFns } from "./ConsentBanner.vue?vue&type=template&id=5c66cf18&scoped=true&"
import script from "./ConsentBanner.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConsentBanner.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ConsentBanner.vue?vue&type=style&index=0&id=5c66cf18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66cf18",
  null
  
)

export default component.exports